import React from 'react'
import '../../../styles/Idecaba.css'
function Collapsible() {
  return (
    <div >
  <div className="d-flex justify-content-center align-items-center w-100">
<div className="accordion accordion-width" id="accordionUniqueSelection">
    <div className="accordion-item ">
        <button
            className="accordion-button collapsed"
            type="button" 
            data-bs-toggle="collapse"
            data-bs-target="#collapseOneUniqueSelection"
            aria-expanded="false" 
            aria-controls="collapseOneUniqueSelection"
        >
            <span className="collapse-title">Objetivos Principales</span>
        </button>
        <div id="collapseOneUniqueSelection" className="accordion-collapse collapse" data-bs-parent="#accordionUniqueSelection">
            <div className="accordion-body">
              <p>Facilitar y promover la publicación y el intercambio de información geográfica producida por el
Gobierno de la Ciudad de Buenos Aires de manera interoperable y estandarizada, impulsando
acuerdos de cooperación entre las instituciones relacionadas con la generación y el uso de los
datos. <br/><br/>
Beneficios de contar con una IDECABA :<br/><br/>
» Facilitar el acceso a la información geográfica producida por el GCBA, para
optimizar su análisis mediante un Geoportal de acceso simple, aportando a la toma
de decisiones políticas.<br/><br/>
» Impulsar la producción de información geoespacial de forma normalizada,
estandarizada e interoperable para facilitar su intercambio.<br/><br/>
» Reducir costos y evitar la duplicación de esfuerzos, acrecentando el trabajo
colaborativo entre las áreas de Gobierno, alentando la cooperación
transversal.<br/><br/>
» Integrar la participación de los actores externos que forman parte de la toma
de datos de interés para el GCABA, documentando la definición de modelos
de trabajo y de datos para permitir su consumo bajo los estándares
interoperables de la IDECABA.</p>
            </div>
        </div>
    </div>
    <div className="accordion-item">
        <button
            className="accordion-button collapsed"
            type="button" 
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwoUniqueSelection"
            aria-expanded="false" 
            aria-controls="collapseTwoUniqueSelection"
        >
            
            <span className="collapse-title">Misión</span>
        </button>
        <div id="collapseTwoUniqueSelection" className="accordion-collapse collapse" data-bs-parent="#accordionUniqueSelection">
            <div className="accordion-body">
              <p>IDECABA, es, por ende, el lugar en el cual se podrá consultar, visualizar y consumir información
geográfica de las distintas áreas de la ciudad, de manera centralizada, cumpliendo con todos los
estándares y normas indicadas anteriormente.</p>
            </div>
        </div>
    </div>
</div>
</div></div>

  )
}

export default Collapsible